import { injectGlobal } from 'emotion';
import wyboTheme from 'reapop-theme-wybo';

const c = wyboTheme.notification.className;

// strip 'fa' class
const nofa = (string) => (
  string
    .split(/\s/)
    .filter(c => c !== 'fa')
    .join(' ')
);


// XXX: Can't figure out how to include font icon, like this:
// content: "\e631";

// Override some styles.
injectGlobal`
  .${c.main} {
    font-family: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    border-width: 4px;
    box-shadow: 0 2px 8px rgba(27,39,51, 0.2);
  }

  .${nofa(c.icon)}:before {
    display: none;
  }
`;


export default wyboTheme;



// WEBPACK FOOTER //
// ./src/helpers/repopTheme.js